<template>
<div class="maxlength" :class="(thisValue && thisValue.length > thisMaxlength ? 'error' : '')">
	<input
			type="text"
			:id="id"
			v-model="thisValue"
			:maxlength="thisMaxlength"
			:name="name"
			:placeholder="placeholder"
			:required="required"
			@change="change(thisValue)"
			@keydown.enter.prevent>
	<div class="maxlength__counter"><span class="maxlength__count">{{ thisValue ? thisValue.length : 0 }}</span>/{{ thisMaxlength }}</div>
</div>
</template>

<script>
export default {
	props: {
		id:String,
		name:String,
		maxlength:String,
		value:String,
		placeholder:String,
		change: Function,
		required:{
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			thisValue: this.value,
			thisMaxlength: this.maxlength
		}
	}
}
</script>
